import { env } from "../config/env";

export const getMediaUrl = (key: string | null | undefined): string | null => {
  if (!key) return null;
  // REACT_APP_S3_ENDPOINT is configured with a trailing slash in .env.prod, so
  // joining with another one produced "https://host//key". Trim both sides of
  // the join instead of relying on how the env var happens to be written.
  const storageEndpoint = env.s3Endpoint.replace(/\/+$/, "");
  return `${storageEndpoint}/${key.replace(/^\/+/, "")}`;
};

export const getPhotoUrl = (photoKey: string | null | undefined): string | null => {
  return getMediaUrl(photoKey);
};

export const generatePhotoKey = (file: File, type: 'dealer' | 'retailer' | 'seller' | 'device' = 'dealer'): string => {
  const timestamp = Date.now();
  const cleanFileName = file.name.replace(/[^a-zA-Z0-9.]/g, '_').toLowerCase();
  return `${type.toString()}/photos/${timestamp}-${cleanFileName}`;
};